export default __webpack_public_path__ + "static/media/withlogo.003.cbb6da69.jpeg";